import { EMAIL_1 } from "constants/configConstants";
import Subsection from "../Subsection";
import styles from "./GetHelp.module.scss";
import ContactCard from "./components/ContactCard";
import useTranslationHook from "hooks/useTranslationHook";
import config from "@Config/index";
import LoginDispatcher from "@Components/Login/actions";
import { addLoadZendeskParamInURL } from "@Pages/PropertyPage/data/helper";
import handleChatWidgetOpen from "helpers/handleChatWidgetOpen";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";
import { AppState } from "@Store/index";
import { setOpenAmberCopilot } from "@Pages/PropertyPage/components/ZendeskChat/ChatBotReducer";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import useIsDesktop from "hooks/useIsDesktop";
import getWeComUrlBasedOnSource, {
  HK_WEIXIN_DWEB,
  HK_WEIXIN_MWEB,
} from "helpers/getWeComUrlBasedOnSource";
import emitAiChatInitiatedEvent from "helpers/emitAiChatInitiatedEvent";
import useCountryContactInfo from "hooks/useCountryContactInfo";

const GetHelp = ({ forceTabletMobile = false }: { forceTabletMobile?: boolean }) => {
  const { t } = useTranslationHook();
  const { phoneContact } = useCountryContactInfo();
  const sectionTitle = t("home.gethelp.gethelptitle");
  const sectionSubTitle = t("home.gethelp.gethelpsubtitle");

  const { isLFOneFilled, isUserLoggedIn } = useSelector(({ leadFormModal, appData }: AppState) => ({
    isLFOneFilled: leadFormModal.isLFOneFilled,
    isUserLoggedIn: appData.isUserLoggedIn,
  }));

  const { isWhitelabel } = useWhitelabel();
  const isDesktop = useIsDesktop();
  const [weChatSupportRedirectTo, setWeChatSupportRedirectTo] = useState(
    isDesktop ? HK_WEIXIN_DWEB : HK_WEIXIN_MWEB,
  );

  const isZendeskAfterLogin = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.ZENDESK_LOGIN_POPUP);
  const isAmberCopilotEnabled = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.AMBER_COPILOT);

  const dispatch = useDispatch();

  const handleZendeskCB = () => {
    if (isAmberCopilotEnabled) {
      dispatch(setOpenAmberCopilot(true));
      emitAiChatInitiatedEvent();
      return;
    }
    if (isZendeskAfterLogin && !isUserLoggedIn && !isLFOneFilled) {
      addLoadZendeskParamInURL();
      const loginDispatcher = new LoginDispatcher(dispatch);
      loginDispatcher.showLoginModal({ openingSource: "zendesk" });
    } else {
      handleChatWidgetOpen(true);
    }
  };

  useEffect(() => {
    const { URLDweb, URLMweb } = getWeComUrlBasedOnSource();
    setWeChatSupportRedirectTo(isDesktop ? URLDweb : URLMweb);
  }, [isDesktop]);

  return (
    <Subsection
      title={sectionTitle}
      subtitle={sectionSubTitle}
      greyBg
      isDesktop={!forceTabletMobile && isDesktop}
    >
      <div className={styles.contactCardsContainer}>
        <div className={styles.contactCardRow}>
          {!isWhitelabel && (
            <ContactCard
              label="home.contactus.livechat"
              iconKey="liveChat"
              showTag
              dataTestId="mobile-needHelp-liveChat"
              handleZendeskCB={handleZendeskCB}
            />
          )}
          {config.IS_CHINA_APP ? (
            <ContactCard
              label="home.contactus.chatonwechat"
              iconKey="weChat"
              showTag
              href={weChatSupportRedirectTo}
              isDesktop
            />
          ) : (
            <ContactCard
              label="home.contactus.chatonwhatsapp"
              iconKey="whatsapp"
              showTag
              href="https://api.whatsapp.com/send/?phone=447888863490&text&type=phone_number&app_absent=0"
              isDesktop
              dataTestId="mobile-needHelp-Whatsapp"
            />
          )}
        </div>
        <div className={styles.contactCardRow}>
          <ContactCard
            label={t("home.contactus.emailus")}
            iconKey="email"
            href={`mailto:${EMAIL_1}`}
            dataTestId="mobile-needHelp-email"
          />
          {config.IS_CHINA_APP ? (
            <></>
          ) : (
            <ContactCard
              label={phoneContact?.label}
              iconKey="phone"
              href={phoneContact?.link}
              isDesktop
              dataTestId="mobile-needHelp-MobileNumber"
            />
          )}
        </div>
      </div>
    </Subsection>
  );
};

export default wrapperHOC(GetHelp, {
  componentName: "GetHelp-Home",
  showForChina: true,
  showForMiniProgram: false,
});
